import { Grid2, Typography } from "@mui/material";
import InputComponent from "components/appInput";
import CustomModalRegister from "components/concert/modalRegister";
import React, { useState } from "react";
import "./index.scss";
import { checkNationalId } from "utils/checkNationalId";
import { useSubmitNationalIdUser } from "hooks/event";
import useInfoContext from "hooks/useInfoContext";

const ModalRejisterUser = ({
  open,
  handleClose,
  step,
  setStep,
  clientInfo,
}) => {
  const [birthday, setBirthday] = useState("");
  const [nationalId, setNationalId] = useState("");
  const [alertText, setAlertText] = useState("");
  const { mutate: submitNationalIdUser, isLoading } = useSubmitNationalIdUser();
  const { repToken, userIdRegistration } = useInfoContext();

  const handleBirthdayChange = (value) => {
    console.log("Selected Birthday:", value);
    setBirthday(value);
  };
  const handleNationalId = (value) => {
    console.log("Selected Birthday:", value);
    setNationalId(value);
  };

  const handleRegisterUser = () => {
    let valid = true;
    if (!checkNationalId(nationalId)) {
      valid = false;
      setAlertText("اطلاعات وارد شده صحیح نیست");
    }
    if (valid && userIdRegistration && repToken) {
      submitNationalIdUser(
        {
          clientId: userIdRegistration,
          nationalId: nationalId,
          birthDate: birthday,
          repToken: repToken,
        },
        {
          onSuccess: (response) => {
            if (response.status === "OK") {
              setStep(3);
            }
          },
          onError: (error) => {
            console.log("error!", error);
            if (error.response.data.status === "ERROR! NATIONAL ID EXISTS!") {
              setAlertText("کد ملی قبلا در سیستم ثبت شده");
            } else {
              setAlertText("اطلاعات وارد شده صحیح نیست");
            }
          },
        }
      );
    }
  };

  return (
    <CustomModalRegister
      open={open}
      handleClose={handleClose}
      title="افزودن همراه"
      activeStep={step + 1}
      titleBody="احراز هویت همراه شما"
      buttonFunction={handleRegisterUser}
      disabledButton={!nationalId && !birthday}
      buttonText="احراز هویت"
      loadingButton={isLoading}
    >
      <Grid2 item size={{ xs: 12 }} className="container-register-user">
        <Typography variant="h6" className="description-register">
          برای شرکت همراه شما در کنسرت، نیاز به تکمیل فرایند احراز هویت می باشد.
        </Typography>

        <InputComponent
          type="number"
          value={nationalId}
          placeholder="کد ملی"
          handleValue={handleNationalId}
          dir="rtl"
          error={alertText}
        />
        <InputComponent
          type="birthday"
          value={birthday}
          placeholder="تاریخ تولد"
          handleValue={handleBirthdayChange}
          dir="rtl"
          error={alertText}
          alertText={alertText}
        />
      </Grid2>
    </CustomModalRegister>
  );
};

export default ModalRejisterUser;
